import LegalLayout, { H } from "../../components/LegalLayout";

export default function Cookies() {
  return (
    <LegalLayout title="Política de Cookies" updated="Junio 2026">
      <p>
        Esta política de cookies explica qué son las cookies, cómo las utiliza JordyBT_Fitness — Elite Coaching y
        cómo puedes gestionarlas, en cumplimiento de la Ley 34/2002 de Servicios de la Sociedad de la Información y
        de Comercio Electrónico (LSSI-CE) y del RGPD.
      </p>

      <H>1. ¿Qué son las cookies?</H>
      <p>
        Las cookies son pequeños archivos de texto que los sitios web almacenan en el dispositivo del usuario al
        navegar. Permiten recordar información sobre la visita y mejorar la experiencia de navegación.
      </p>

      <H>2. Tipos de cookies que utilizamos</H>
      <ul className="list-disc pl-6 space-y-2">
        <li>
          <strong className="text-white">Cookies técnicas (necesarias):</strong> imprescindibles para el correcto
          funcionamiento de la web y la gestión del formulario y la reserva.
        </li>
        <li>
          <strong className="text-white">Cookies de análisis:</strong> nos permiten medir y analizar el
          comportamiento de los usuarios de forma anónima para mejorar el servicio.
        </li>
        <li>
          <strong className="text-white">Cookies de preferencias:</strong> almacenan tus elecciones, como la
          aceptación del aviso de cookies.
        </li>
      </ul>

      <H>3. Gestión y desactivación</H>
      <p>
        Puedes aceptar o rechazar el uso de cookies a través del banner que se muestra al acceder a la web. Además,
        puedes configurar tu navegador para bloquear o eliminar las cookies en cualquier momento. Ten en cuenta que
        desactivar determinadas cookies puede afectar al funcionamiento de algunas partes del sitio.
      </p>

      <H>4. Consentimiento</H>
      <p>
        Al continuar navegando o al pulsar “Aceptar” en el banner de cookies, consientes el uso de las cookies
        descritas. Puedes retirar tu consentimiento en cualquier momento eliminando las cookies desde tu navegador.
      </p>
    </LegalLayout>
  );
}
